import type { ApInvoiceListReturnContext } from "@/accounts-payable/types";
import { AP_TAB, apListPath } from "@/accounts-payable/utils";

/** The list itself, by its old `?tab=` address or by one per tab. */
const LIST_PATHS = [
  apListPath(),
  ...Object.values(AP_TAB).map((tab) => apListPath(tab)),
];

export const isInvoiceListReturnContext = (
  value: unknown,
): value is ApInvoiceListReturnContext => {
  if (!value || typeof value !== "object") return false;
  if (
    !("businessId" in value) ||
    typeof value.businessId !== "string" ||
    !("listPath" in value) ||
    typeof value.listPath !== "string"
  )
    return false;
  const path = value.listPath;
  return LIST_PATHS.some(
    (listPath) =>
      path === listPath ||
      path.startsWith(`${listPath}?`) ||
      path.startsWith(`${listPath}#`),
  );
};

/** Only return to a local AP list from the same business. */
export const readInvoiceListReturnPath = (
  state: unknown,
  businessId: string | null,
): string | null => {
  if (
    !businessId ||
    !state ||
    typeof state !== "object" ||
    !("invoiceListReturnContext" in state)
  )
    return null;
  const context = state.invoiceListReturnContext;
  return isInvoiceListReturnContext(context) &&
    context.businessId === businessId
    ? context.listPath
    : null;
};
